import React from "react";
import { architectureProjects } from '../../libs/data'
import ProjectPage from '../ProjectPage/ProjectPage'
// import ProjectPage from '../../pages/ProjectPage/ProjectPage'


function Architecture() {

    const renderProjects = () => {
        return (
            <div className='projects'>
                {architectureProjects.map((dato) => {
              return (
                
                      <ProjectPage
                        headerText={dato.headerText}
                        imgSrc={dato.imgSrc}
                        videoSrc={dato.videoSrc}
                        chapters={dato.chapters}
                        videos={dato.videos}
                        videoHeader={dato.videoHeader}
                        imgZoom={dato.imgZoom}
                        glitch={dato.glitch}
                      />
              );
            })}
            </div>
        )
    }
  return (
      <div className='Architecture'>
          {/* <Hero title='' subtitle={`I'm a graduate student of architecture interested in enhancing spaces with technology.`} content='Scroll down to see some of my projects'/> */}
            {renderProjects()}
      </div>
  ) 
}

export default Architecture;
